import React from 'react';

import Connect from './connect';
import Disconnect from './disconnect';
import NylasGrant from './index';
import Status from './status';
import microsoftLogo from 'assets/images/logos/microsoft.svg';
import outlookIcon from 'assets/images/logos/outlook.svg';
import { formatDate } from 'helpers/formatters/date_time_formats';

import { scopesFor } from './scopes';

import type { GrantProps } from './types';

export function MicrosoftGrant({ grant, paths, canSendEmail, onDestroy }: GrantProps) {
  const canConnect = !grant || grant.expired || grant.requiresReconnectionBy;
  const scopes = scopesFor('microsoft', canSendEmail);

  let subtitle: React.ReactNode;
  if (grant && !grant.expired && grant.requiresReconnectionBy) {
    const date = <span className="fw-semibold">{formatDate(grant.requiresReconnectionBy)}</span>;
    subtitle = (
      <span>
        Your authentication to Outlook is set to expire in the next 6 months on {date}.
        Please reconnect for continued access.
      </span>
    );
  } else {
    subtitle = 'Outlook requires reconnection every 2 years.';
  }

  return (
    <NylasGrant
      icon={outlookIcon}
      label="Outlook"
      status={grant && <Status grant={grant} />}
      subtitle={subtitle}
    >
      {canConnect &&
        <Connect
          grant={grant}
          icon={microsoftLogo}
          label="Microsoft"
          path={paths.auth}
          providerName="microsoft"
          scopes={scopes}
        />
      }

      {grant &&
        <Disconnect
          destroyPath={paths.destroy}
          variant={canConnect ? 'destructive' : 'ghost'}
          onDestroy={onDestroy}
        />
      }
    </NylasGrant>
  );
}
